<template>
	<button type="button" @click="onClick"><IconTrashAlt />&nbsp;</button>
</template>

<script>
	import IconTrashAlt from "@/components/icons/IconTrashAlt"

	export default {
		components: {
			IconTrashAlt
		},
		methods: {
			onClick() {
				this.$modal.show("delete-song");
			}
		}

	}

</script>

<style lang="scss" scoped>
	button {
		width: 48px;

		.icon-trash-alt {
			width: 20px;
			margin: 6px 0 0 -6px;
			position: absolute;
		}
	}
</style>
